import {getGlobalParameter} from "../model";
import {stores} from "../stores";

function checkCondition(condition: any): boolean {
    if ("conditionsOr" in condition) {
        return checkConditionsOr(condition.conditionsOr);
    }

    let param = getGlobalParameter(condition.param);
    if (param) {
        let value = stores.memory.getValue(param);
        let op = condition.op ?? "eq";
        switch (op.toLowerCase()) {
            case "eq":
                return value === condition.value;
            case "ne":
                return value !== condition.value;
            case "gt":
                return value > condition.value;
            case "lt":
                return value < condition.value;
            case "ge":
                return value >= condition.value;
            case "le":
                return value <= condition.value;
            default:
                console.warn("condition param operator not supported ", condition);
                return false;
        }
    } else {
        console.warn("condition param not found", condition);
        return false;
    }
}

function checkConditionsOr(conditions: any[]): boolean {
    if (conditions.length === 0) {
        return true; // If there are no conditions, we consider it as true
    }
    for (let cond of conditions) {
        if (checkCondition(cond)) {
            return true; // If any condition is true, return true
        }
    }
    return false; // If all conditions are false, return false
}

export function conditionsOk(item: any): boolean {
    if ("condition" in item) {
        return checkCondition(item.condition);
    }

    if ("conditions" in item) {
        for (let cond of item.conditions) {
            if (!checkCondition(cond)) {
                return false;
            }
        }
    }

    if ("conditionsOr" in item) {
        return checkConditionsOr(item.conditionsOr);
    }

    return true; // If no conditions are specified, return true
}